import {api} from 'app/services/api';
import {changeHeaderText} from 'app/actions/headerActions';
import {catchDataError, checkApiRedirect, RedirectException} from 'app/helpers/apiHelpers';
import {trySettingDefaultDistrict} from 'app/actions/sessionActions';
import {updateHistory} from 'app/actions/historyActions';
import {getRedirectVideo} from 'app/components/tv/helpers/lastViewedVideos';
import {updateHttpError} from 'app/components/error/ErrorHandlerActions';

const getPlaylist = slug => {
  return api.get(`/playlists/${slug}/videos`);
};

function fetchingPlaylist() {
  return {
    type: 'PLAYLIST_FETCHING',
  };
}

function updatePlaylist(data) {
  return {
    type: 'PLAYLIST_UPDATE',
    data,
  };
}

function addPlaylistVideo(data) {
  return {
    type: 'ADD_PLAYLIST_VIDEO',
    data,
  };
}

function updateCurrentVideo(data) {
  return {
    type: 'CURRENT_VIDEO_UPDATE',
    data,
  };
}

function setPlaylistHeader(dispatch) {
  dispatch(
    changeHeaderText({
      title: 'Torshow',
      parent: {
        name: 'FuPa.tv',
        entity: 'none',
      },
    })
  );
}

const getPlaylistDistrictEntity = playlist => {
  const firstVideo = playlist[0];
  return firstVideo.user?.district?.slug ? firstVideo.user : firstVideo.match?.competition;
};

function fetchTvPlaylistSSR(playlistSlug, currentVideoSlug) {
  return async function (dispatch, getState) {
    setPlaylistHeader(dispatch);
    try {
      let response = await getPlaylist(playlistSlug);
      const data = response.data;
      checkApiRedirect(data[0]?.matchPlaylist, playlistSlug, null, null, getState);
      // search for video in playlist, that is passed with the url param
      const currentVideo = data.find(video => video.slug === currentVideoSlug) ?? {};
      dispatch(
        updateHistory('undefined', {
          store: 'TvPlaylistPage',
          data: {items: data, currentVideo, isFetching: false, error: null},
        })
      );
      if (data.length) {
        const entity = getPlaylistDistrictEntity(data);
        // Return the Promise to make sure further handlers wait until it settles -> ssr rendered page is sent after setDefaultDistrict has finished
        return trySettingDefaultDistrict(entity, dispatch, getState);
      }
    } catch (error) {
      if (error instanceof RedirectException) {
        throw error;
      } else {
        const errorData = catchDataError(error);
        dispatch(updateHttpError(errorData));
      }
    }
  };
}

function fetchTvPlaylist(playlistSlug, currentVideoSlug, dispatchRedux, getState) {
  return function (dispatch, state) {
    setPlaylistHeader(dispatchRedux);
    if (state.items.length || state.error) {
      return;
    }
    dispatch(fetchingPlaylist());
    return getPlaylist(playlistSlug)
      .then(response => {
        const data = response.data;
        checkApiRedirect(data[0]?.matchPlaylist, playlistSlug, null, null);
        // search for video in playlist, that is passed with the url param
        const currentVideo = data.find(video => video.slug === currentVideoSlug) ?? getRedirectVideo(data);
        dispatch(updatePlaylist({playlist: data, currentVideo}));
        if (data.length) {
          const entity = getPlaylistDistrictEntity(data);
          return trySettingDefaultDistrict(entity, dispatchRedux, getState);
        }
      })
      .catch(error => {
        if (error instanceof RedirectException) {
          throw error;
        } else {
          const errorData = catchDataError(error);
          dispatchRedux(updateHttpError(errorData));
        }
      });
  };
}

export {fetchTvPlaylistSSR, fetchTvPlaylist, updateCurrentVideo, addPlaylistVideo};
